import * as React from 'react';
import { RichTextArea } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachRichText } from '../../hooks/use-bloomreach-rich-text.js';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsDocument = ({ content  })=>{
    var ref;
    const richText = useBloomreachRichText((ref = content.content) === null || ref === void 0 ? void 0 : ref.value);
    if (!richText) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(RichTextArea, {
        content: richText
    });
};
var Document = compose(withBreakpointVisibility, withHidableContent, withBloomreachData, withEditableContent, withAnchor)(CmsDocument);

export { CmsDocument, Document as default };
//# sourceMappingURL=Document.js.map
